// https://github.com/mozilla/language-mapping-list/blob/master/language-mapping-list.js
const langNameMap: any = {
  ach: { nativeName: 'Lwo', englishName: 'Acholi' },
  ady: { nativeName: 'Адыгэбзэ', englishName: 'Adyghe' },
  af: { nativeName: 'Afrikaans', englishName: 'Afrikaans' },
  af_na: {
    nativeName: 'Afrikaans (Namibia)',
    englishName: 'Afrikaans (Namibia)'
  },
  af_za: {
    nativeName: 'Afrikaans (South Africa)',
    englishName: 'Afrikaans (South Africa)'
  },
  ak: { nativeName: 'Tɕɥi', englishName: 'Akan' },
  ar: { nativeName: 'العربية', englishName: 'Arabic' },
  ar_ar: { nativeName: 'العربية', englishName: 'Arabic' },
  ar_ma: { nativeName: 'العربية', englishName: 'Arabic (Morocco)' },
  ar_sa: {
    nativeName: 'العربية (السعودية)',
    englishName: 'Arabic (Saudi Arabia)'
  },
  ay_bo: { nativeName: 'Aymar aru', englishName: 'Aymara' },
  az: { nativeName: 'Azərbaycan dili', englishName: 'Azerbaijani' },
  az_az: { nativeName: 'Azərbaycan dili', englishName: 'Azerbaijani' },
  be: { nativeName: 'Беларуская', englishName: 'Belarusian' },
  be_by: { nativeName: 'Беларуская', englishName: 'Belarusian' },
  bg: { nativeName: 'Български', englishName: 'Bulgarian' },
  bg_bg: { nativeName: 'Български', englishName: 'Bulgarian' },
  bn: { nativeName: 'বাংলা', englishName: 'Bengali' },
  bn_in: { nativeName: 'বাংলা (ভারত)', englishName: 'Bengali (India)' },
  bn_bd: { nativeName: 'বাংলা(বাংলাদেশ)', englishName: 'Bengali (Bangladesh)' },
  bs_ba: { nativeName: 'Bosanski', englishName: 'Bosnian' },
  ca: { nativeName: 'Català', englishName: 'Catalan' },
  ca_es: { nativeName: 'Català', englishName: 'Catalan' },
  cak: { nativeName: 'Maya Kaqchikel', englishName: 'Kaqchikel' },
  ck_us: { nativeName: 'ᏣᎳᎩ (tsalagi)', englishName: 'Cherokee' },
  cs: { nativeName: 'Čeština', englishName: 'Czech' },
  cs_cz: { nativeName: 'Čeština', englishName: 'Czech' },
  cy: { nativeName: 'Cymraeg', englishName: 'Welsh' },
  cy_gb: { nativeName: 'Cymraeg', englishName: 'Welsh' },
  da: { nativeName: 'Dansk', englishName: 'Danish' },
  da_dk: { nativeName: 'Dansk', englishName: 'Danish' },
  de: { nativeName: 'Deutsch', englishName: 'German' },
  de_at: {
    nativeName: 'Deutsch (Österreich)',
    englishName: 'German (Austria)'
  },
  de_de: {
    nativeName: 'Deutsch (Deutschland)',
    englishName: 'German (Germany)'
  },
  de_ch: {
    nativeName: 'Deutsch (Schweiz)',
    englishName: 'German (Switzerland)'
  },
  dsb: { nativeName: 'Dolnoserbšćina', englishName: 'Lower Sorbian' },
  el: { nativeName: 'Ελληνικά', englishName: 'Greek' },
  el_gr: { nativeName: 'Ελληνικά', englishName: 'Greek (Greece)' },
  en: { nativeName: 'English', englishName: 'English' },
  en_gb: { nativeName: 'English (UK)', englishName: 'English (UK)' },
  en_au: {
    nativeName: 'English (Australia)',
    englishName: 'English (Australia)'
  },
  en_ca: { nativeName: 'English (Canada)', englishName: 'English (Canada)' },
  en_ie: { nativeName: 'English (Ireland)', englishName: 'English (Ireland)' },
  en_in: { nativeName: 'English (India)', englishName: 'English (India)' },
  en_pi: { nativeName: 'English (Pirate)', englishName: 'English (Pirate)' },
  en_sg: { nativeName: 'English (Singapore)', englishName: 'English (Singapore)' },
  en_ud: {
    nativeName: 'English (Upside Down)',
    englishName: 'English (Upside Down)'
  },
  en_us: { nativeName: 'English (US)', englishName: 'English (US)' },
  en_za: {
    nativeName: 'English (South Africa)',
    englishName: 'English (South Africa)'
  },
  en_kr: { nativeName: 'English (Korea)', englishName: 'English (Korea)' },
  en_cn: { nativeName: 'English (China)', englishName: 'English (China)' },
  'en@pirate': {
    nativeName: 'English (Pirate)',
    englishName: 'English (Pirate)'
  },
  eo: { nativeName: 'Esperanto', englishName: 'Esperanto' },
  eo_eo: { nativeName: 'Esperanto', englishName: 'Esperanto' },
  es: { nativeName: 'Español', englishName: 'Spanish' },
  es_ar: {
    nativeName: 'Español (Argentine)',
    englishName: 'Spanish (Argentina)'
  },
  es_419: {
    nativeName: 'Español (Latinoamérica)',
    englishName: 'Spanish (Latin America)'
  },
  es_cl: { nativeName: 'Español (Chile)', englishName: 'Spanish (Chile)' },
  es_co: {
    nativeName: 'Español (Colombia)',
    englishName: 'Spanish (Colombia)'
  },
  es_ec: { nativeName: 'Español (Ecuador)', englishName: 'Spanish (Ecuador)' },
  es_es: { nativeName: 'Español (España)', englishName: 'Spanish (Spain)' },
  es_la: {
    nativeName: 'Español (Latinoamérica)',
    englishName: 'Spanish (Latin America)'
  },
  es_ni: {
    nativeName: 'Español (Nicaragua)',
    englishName: 'Spanish (Nicaragua)'
  },
  es_mx: { nativeName: 'Español (México)', englishName: 'Spanish (Mexico)' },
  es_us: {
    nativeName: 'Español (Estados Unidos)',
    englishName: 'Spanish (United States)'
  },
  es_ve: {
    nativeName: 'Español (Venezuela)',
    englishName: 'Spanish (Venezuela)'
  },
  et: { nativeName: 'Eesti Keel', englishName: 'Estonian' },
  et_ee: { nativeName: 'Eesti (Estonia)', englishName: 'Estonian (Estonia)' },
  eu: { nativeName: 'Euskara', englishName: 'Basque' },
  eu_es: { nativeName: 'Euskara', englishName: 'Basque' },
  fa: { nativeName: 'فارسی', englishName: 'Persian' },
  fa_ir: { nativeName: 'فارسی', englishName: 'Persian' },
  fb_lt: { nativeName: 'Leet Speak', englishName: 'Leet' },
  ff: { nativeName: 'Fulah', englishName: 'Fulah' },
  fi: { nativeName: 'Suomi', englishName: 'Finnish' },
  fi_fi: { nativeName: 'Suomi', englishName: 'Finnish' },
  fo_fo: { nativeName: 'Føroyskt', englishName: 'Faroese' },
  fr: { nativeName: 'Français', englishName: 'French' },
  fr_ca: { nativeName: 'Français (Canada)', englishName: 'French (Canada)' },
  fr_fr: { nativeName: 'Français (France)', englishName: 'French (France)' },
  fr_be: { nativeName: 'Français (Belgique)', englishName: 'French (Belgium)' },
  fr_ch: {
    nativeName: 'Français (Suisse)',
    englishName: 'French (Switzerland)'
  },
  fy_nl: { nativeName: 'Frysk', englishName: 'Frisian (West)' },
  ga: { nativeName: 'Gaeilge', englishName: 'Irish' },
  ga_ie: { nativeName: 'Gaeilge (Gaelic)', englishName: 'Irish (Gaelic)' },
  gl: { nativeName: 'Galego', englishName: 'Galician' },
  gl_es: { nativeName: 'Galego', englishName: 'Galician' },
  gn_py: { nativeName: "Avañe'ẽ", englishName: 'Guarani' },
  gu_in: { nativeName: 'ગુજરાતી', englishName: 'Gujarati' },
  gx_gr: { nativeName: 'Ἑλληνική ἀρχαία', englishName: 'Classical Greek' },
  he: { nativeName: 'עברית‏', englishName: 'Hebrew' },
  he_il: { nativeName: 'עברית‏', englishName: 'Hebrew' },
  hi: { nativeName: 'हिन्दी', englishName: 'Hindi' },
  hi_in: { nativeName: 'हिन्दी', englishName: 'Hindi' },
  hr: { nativeName: 'Hrvatski', englishName: 'Croatian' },
  hr_hr: { nativeName: 'Hrvatski', englishName: 'Croatian' },
  hsb: { nativeName: 'Hornjoserbšćina', englishName: 'Upper Sorbian' },
  ht: { nativeName: 'Kreyòl', englishName: 'Haitian Creole' },
  hu: { nativeName: 'Magyar', englishName: 'Hungarian' },
  hu_hu: { nativeName: 'Magyar', englishName: 'Hungarian' },
  hy_am: { nativeName: 'Հայերեն', englishName: 'Armenian' },
  id: { nativeName: 'Bahasa Indonesia', englishName: 'Indonesian' },
  id_id: { nativeName: 'Bahasa Indonesia', englishName: 'Indonesian' },
  is: { nativeName: 'Íslenska', englishName: 'Icelandic' },
  is_is: {
    nativeName: 'Íslenska (Iceland)',
    englishName: 'Icelandic (Iceland)'
  },
  it: { nativeName: 'Italiano', englishName: 'Italian' },
  it_it: { nativeName: 'Italiano', englishName: 'Italian' },
  ja: { nativeName: '日本語', englishName: 'Japanese' },
  ja_jp: { nativeName: '日本語', englishName: 'Japanese' },
  jv_id: { nativeName: 'Basa Jawa', englishName: 'Javanese' },
  ka_ge: { nativeName: 'ქართული', englishName: 'Georgian' },
  kk_kz: { nativeName: 'Қазақша', englishName: 'Kazakh' },
  km: { nativeName: 'ភាសាខ្មែរ', englishName: 'Khmer' },
  km_kh: { nativeName: 'ភាសាខ្មែរ', englishName: 'Khmer' },
  kab: { nativeName: 'Taqbaylit', englishName: 'Kabyle' },
  kn: { nativeName: 'ಕನ್ನಡ', englishName: 'Kannada' },
  kn_in: { nativeName: 'ಕನ್ನಡ (India)', englishName: 'Kannada (India)' },
  ko: { nativeName: '한국어', englishName: 'Korean' },
  ko_kr: { nativeName: '한국어 (韩国)', englishName: 'Korean (Korea)' },
  ku_tr: { nativeName: 'Kurdî', englishName: 'Kurdish' },
  la: { nativeName: 'Latin', englishName: 'Latin' },
  la_va: { nativeName: 'Latin', englishName: 'Latin' },
  lb: { nativeName: 'Lëtzebuergesch', englishName: 'Luxembourgish' },
  li_nl: { nativeName: 'Lèmbörgs', englishName: 'Limburgish' },
  lt: { nativeName: 'Lietuvių', englishName: 'Lithuanian' },
  lt_lt: { nativeName: 'Lietuvių', englishName: 'Lithuanian' },
  lv: { nativeName: 'Latviešu', englishName: 'Latvian' },
  lv_lv: { nativeName: 'Latviešu', englishName: 'Latvian' },
  mai: { nativeName: 'मैथिली, মৈথিলী', englishName: 'Maithili' },
  mg_mg: { nativeName: 'Malagasy', englishName: 'Malagasy' },
  mk: { nativeName: 'Македонски', englishName: 'Macedonian' },
  mk_mk: {
    nativeName: 'Македонски (Македонски)',
    englishName: 'Macedonian (Macedonian)'
  },
  ml: { nativeName: 'മലയാളം', englishName: 'Malayalam' },
  ml_in: { nativeName: 'മലയാളം', englishName: 'Malayalam' },
  mn_mn: { nativeName: 'Монгол', englishName: 'Mongolian' },
  mr: { nativeName: 'मराठी', englishName: 'Marathi' },
  mr_in: { nativeName: 'मराठी', englishName: 'Marathi' },
  ms: { nativeName: 'Bahasa Melayu', englishName: 'Malay' },
  ms_my: { nativeName: 'Bahasa Melayu', englishName: 'Malay' },
  mt: { nativeName: 'Malti', englishName: 'Maltese' },
  mt_mt: { nativeName: 'Malti', englishName: 'Maltese' },
  my: { nativeName: 'ဗမာစကာ', englishName: 'Burmese' },
  no: { nativeName: 'Norsk', englishName: 'Norwegian' },
  nb: { nativeName: 'Norsk (bokmål)', englishName: 'Norwegian (bokmal)' },
  nb_no: { nativeName: 'Norsk (bokmål)', englishName: 'Norwegian (bokmal)' },
  ne: { nativeName: 'नेपाली', englishName: 'Nepali' },
  ne_np: { nativeName: 'नेपाली', englishName: 'Nepali' },
  nl: { nativeName: 'Nederlands', englishName: 'Dutch' },
  nl_be: { nativeName: 'Nederlands (België)', englishName: 'Dutch (Belgium)' },
  nl_nl: {
    nativeName: 'Nederlands (Nederland)',
    englishName: 'Dutch (Netherlands)'
  },
  nn_no: { nativeName: 'Norsk (nynorsk)', englishName: 'Norwegian (nynorsk)' },
  oc: { nativeName: 'Occitan', englishName: 'Occitan' },
  or_in: { nativeName: 'ଓଡ଼ିଆ', englishName: 'Oriya' },
  pa: { nativeName: 'ਪੰਜਾਬੀ', englishName: 'Punjabi' },
  pa_in: { nativeName: 'ਪੰਜਾਬੀ (ਭਾਰਤ ਨੂੰ)', englishName: 'Punjabi (India)' },
  pl: { nativeName: 'Polski', englishName: 'Polish' },
  pl_pl: { nativeName: 'Polski', englishName: 'Polish' },
  ps_af: { nativeName: 'پښتو', englishName: 'Pashto' },
  pt: { nativeName: 'Português', englishName: 'Portuguese' },
  pt_br: {
    nativeName: 'Português (Brasil)',
    englishName: 'Portuguese (Brazil)'
  },
  pt_pt: {
    nativeName: 'Português (Portugal)',
    englishName: 'Portuguese (Portugal)'
  },
  qu_pe: { nativeName: 'Qhichwa', englishName: 'Quechua' },
  rm_ch: { nativeName: 'Rumantsch', englishName: 'Romansh' },
  ro: { nativeName: 'Română', englishName: 'Romanian' },
  ro_ro: { nativeName: 'Română', englishName: 'Romanian' },
  ru: { nativeName: 'Русский', englishName: 'Russian' },
  ru_ru: { nativeName: 'Русский', englishName: 'Russian' },
  sa_in: { nativeName: 'संस्कृतम्', englishName: 'Sanskrit' },
  se_no: { nativeName: 'Davvisámegiella', englishName: 'Northern Sámi' },
  si_lk: { nativeName: 'පළාත', englishName: 'Sinhala (Sri Lanka)' },
  sk: { nativeName: 'Slovenčina', englishName: 'Slovak' },
  sk_sk: {
    nativeName: 'Slovenčina (Slovakia)',
    englishName: 'Slovak (Slovakia)'
  },
  sl: { nativeName: 'Slovenščina', englishName: 'Slovenian' },
  sl_si: { nativeName: 'Slovenščina', englishName: 'Slovenian' },
  so_so: { nativeName: 'Soomaaliga', englishName: 'Somali' },
  sq: { nativeName: 'Shqip', englishName: 'Albanian' },
  sq_al: { nativeName: 'Shqip', englishName: 'Albanian' },
  sr: { nativeName: 'Српски', englishName: 'Serbian' },
  sr_rs: { nativeName: 'Српски (Serbia)', englishName: 'Serbian (Serbia)' },
  su: { nativeName: 'Basa Sunda', englishName: 'Sundanese' },
  sv: { nativeName: 'Svenska', englishName: 'Swedish' },
  sv_se: { nativeName: 'Svenska', englishName: 'Swedish' },
  sw: { nativeName: 'Kiswahili', englishName: 'Swahili' },
  sw_ke: { nativeName: 'Kiswahili', englishName: 'Swahili (Kenya)' },
  ta: { nativeName: 'தமிழ்', englishName: 'Tamil' },
  ta_in: { nativeName: 'தமிழ்', englishName: 'Tamil' },
  te: { nativeName: 'తెలుగు', englishName: 'Telugu' },
  te_in: { nativeName: 'తెలుగు', englishName: 'Telugu' },
  tg: { nativeName: 'забо́ни тоҷикӣ́', englishName: 'Tajik' },
  tg_tj: { nativeName: 'тоҷикӣ', englishName: 'Tajik' },
  th: { nativeName: 'ภาษาไทย', englishName: 'Thai' },
  th_th: { nativeName: 'ภาษาไทย (ประเทศไทย)', englishName: 'Thai (Thailand)' },
  tl: { nativeName: 'Filipino', englishName: 'Filipino' },
  tl_ph: { nativeName: 'Filipino', englishName: 'Filipino' },
  tlh: { nativeName: 'tlhIngan-Hol', englishName: 'Klingon' },
  tr: { nativeName: 'Türkçe', englishName: 'Turkish' },
  tr_tr: { nativeName: 'Türkçe', englishName: 'Turkish' },
  tt_ru: { nativeName: 'татарча', englishName: 'Tatar' },
  uk: { nativeName: 'Українська', englishName: 'Ukrainian' },
  uk_ua: { nativeName: 'Українська', englishName: 'Ukrainian' },
  ur: { nativeName: 'اردو', englishName: 'Urdu' },
  ur_pk: { nativeName: 'اردو', englishName: 'Urdu' },
  uz: { nativeName: "O'zbek", englishName: 'Uzbek' },
  uz_uz: { nativeName: "O'zbek", englishName: 'Uzbek' },
  vi: { nativeName: 'Tiếng Việt', englishName: 'Vietnamese' },
  vi_vn: { nativeName: 'Tiếng Việt', englishName: 'Vietnamese' },
  xh_za: { nativeName: 'isiXhosa', englishName: 'Xhosa' },
  yi: { nativeName: 'ייִדיש', englishName: 'Yiddish' },
  yi_de: { nativeName: 'ייִדיש (German)', englishName: 'Yiddish (German)' },
  zh: { nativeName: '中文', englishName: 'Chinese' },
  zh_hans: { nativeName: '简体中文', englishName: 'Chinese Simplified' },
  zh_hant: { nativeName: '繁體中文', englishName: 'Chinese Traditional' },
  zh_cn: {
    nativeName: '中文（简体）',
    englishName: 'Chinese Simplified'
  },
  zh_hk: {
    nativeName: '繁體中文（香港）',
    englishName: 'Chinese Traditional (Hong Kong)'
  },
  tc_cn: {
    nativeName: '中文（繁體）', englishName: 'Chinese Traditional (China)'
  },
  bo_cn: {
    nativeName: 'བོད་སྐད་', englishName: 'Uyghur (China)'
  },
  ug_cn: {
    nativeName: 'ئۇيغۇرچە', englishName: 'Tibetan (China)'
  },
  /*zh_sg: {
    nativeName: '中文（新加坡）',
    englishName: 'Chinese Simplified (Singapore)',
  },*/
  zh_tw: {
    nativeName: '繁體中文（台灣）',
    englishName: 'Chinese Traditional (Taiwan)'
  },
  zu_za: { nativeName: 'isiZulu', englishName: 'Zulu' }
};

export const getLangName = (
  lang: string
): { nativeName: string; englishName: string } => {
  const langName = langNameMap[lang];
  if (langName) {
    return langName;
  }
  const fallback = lang.split('_')[0];
  return langNameMap[fallback];
};
